module.exports = __webpack_public_path__ + "img/puregym-logo.365fbc0d.svg";